import React from 'react';
import { withFormik } from 'formik';
import * as Yup from 'yup';
import FormLabelWithField from 'components/Core/FormLabelWithField';
import Button from 'components/Core/Button';
import Select from 'components/Core/Select';
import TextField from 'components/Core/TextField';
import { getFormValid } from 'utils/formUtils';
import EmbedForm from '../EmbeddableForm';
import EmbedLink from '../EmbedLink';
import { AvgElectricityRate, ClimateRegion, CapacityRange, SEERValues } from './content';

const SeerEnergyCalc = ({
  isEmbed,
  openCopyEmbedLinkDialog,
  onCalc,
  pathUrl,
  saveValues,
  ...otherProps
}) => {
  const { values, setFieldValue, handleSubmit, touched, submitCount, errors } = otherProps;

  const formValid = getFormValid({ errors, submitCount });

  const onLocationChange = (id, value) => {
    const electValue = AvgElectricityRate[ClimateRegion.find((f) => f.value === value).label];
    const newVals = { ...values };
    newVals.energyRate = electValue;
    newVals[id] = value;
    setFieldValue('energyRate', electValue);
    setFieldValue(id, value);
    saveValues(newVals);
  };

  const handleChange = (id, value) => {
    setFieldValue(id, value);
    const newVals = { ...values };
    newVals[id] = value;
    saveValues(newVals);
  };

  return (
    <div className="hvac-form-right-gate-container">
      <div className="hvac-form-total-calculation">
        <div className="hvac-form--form" onSubmit={handleSubmit} data-position="hvac seer form">
          <FormLabelWithField
            label="Location of install"
            formControlProps={{ className: 'hvac-form--form-item' }}
          >
            <Select
              className="seers-calc-drop-down"
              id="location"
              formValid={formValid}
              placeholder="Select climate region"
              options={ClimateRegion}
              handleChange={onLocationChange}
              values={values}
            />
          </FormLabelWithField>

          {values.location && (
            <>
              <FormLabelWithField
                label="Average cost of electricity (KWH)"
                formControlProps={{ className: 'hvac-form--form-item' }}
              >
                <TextField
                  className="seers-calc-drop-down"
                  id="energyRate"
                  type="number"
                  values={values}
                  formValid={formValid}
                  handleChange={handleChange}
                  showOnlyFormError
                />
              </FormLabelWithField>
              <p className="hvac-form--electrate-description">Based on rates listed May 2021</p>
            </>
          )}

          <FormLabelWithField
            label="AC Capacity"
            formControlProps={{ className: 'hvac-form--form-item' }}
          >
            <Select
              className="seers-calc-drop-down"
              id="capacity"
              formValid={formValid}
              placeholder="Select AC capacity"
              options={CapacityRange}
              handleChange={handleChange}
              values={values}
            />
          </FormLabelWithField>

          <FormLabelWithField
            label="Current SEER"
            helperText="The Seasonal Energy Efficiency Ratio (SEER) is an energy efficiency rating for air conditioners.
              The higher the SEER, the better the energy performance, the more you save."
            formControlProps={{ className: 'hvac-form--form-item' }}
          >
            <Select
              className="seers-calc-drop-down"
              id="currentEfficiency"
              values={values}
              formValid={formValid}
              placeholder="Select Current SEER"
              options={SEERValues}
              handleChange={handleChange}
            />
          </FormLabelWithField>

          <FormLabelWithField
            label="New SEER"
            helperText="The Seasonal Energy Efficiency Ratio (SEER) is an energy efficiency rating for air conditioners.
                          The higher the SEER, the better the energy performance, the more you save."
            formControlProps={{ className: 'hvac-form--form-item' }}
          >
            <Select
              className="seers-calc-drop-down"
              id="newEfficiency"
              values={values}
              formValid={formValid}
              placeholder="Select New SEER"
              options={SEERValues}
              handleChange={handleChange}
            />
          </FormLabelWithField>
        </div>
        <Button
          dataPosition="Form - Calculate CTA"
          className="hvac-form-calc-button"
          onClick={() => handleSubmit()}
          button
        >
          Calculate
        </Button>
        <div className="form-embed-link">
          <EmbedLink
            show={!isEmbed}
            openCopyEmbedLinkDialog={openCopyEmbedLinkDialog}
            label="Add calculator to your website"
            pathUrl={pathUrl}
          />
        </div>
      </div>
    </div>
  );
};

const vSchema = Yup.object().shape({
  location: Yup.number().required('Location is required'),
  energyRate: Yup.number().required('Rate is required'),
  capacity: Yup.number().required('Capacity is required'),
  currentEfficiency: Yup.number().required('Current Seer is required'),
  newEfficiency: Yup.number().required('New Seer is required'),
});

export default EmbedForm(
  withFormik({
    validationSchema: vSchema,
    handleSubmit: (values, { props }) => {
      props.onCalc(values);
    },
  })(SeerEnergyCalc),
);
